import React from 'react';
import {Row, Col} from 'antd';
import {useIntl} from 'react-intl';
import FormItem from 'src/shared/components/form-item';
import {Input} from 'formik-antd';
import ButtonComponent from 'src/shared/components/button';
import MainUtils from 'src/shared/utils/main';
import {FiSend} from 'react-icons/fi';
import {useParams} from 'react-router-dom';
import {useSendTestEmail} from '../../hooks/useSendTestEmail';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function TestCampaigns({formik}: any) {
  const {messages} = useIntl();
  const {id} = useParams();
  const {mutate: sendTestEmail, isLoading} = useSendTestEmail();

  const handleSubmit = () => {
    sendTestEmail({...formik.values, Id: id});
  };

  return (
    <Row gutter={[0, 25]}>
      <Col span={24}>
        <div className='message-info-2'>
          {messages['mailing.testText'].toString()}
        </div>
      </Col>
      <Col span={24}>
        <FormItem
          name='TestEmail'
          label={messages['mailing.testEmail'].toString()}
          fieldCommponent={<Input name='TestEmail' />}
        />
      </Col>
      <Col span={24}>
        <Row>
          <Col span={6}></Col>
          <Col span={14}>
            <ButtonComponent
              loading={isLoading}
              onClickAction={handleSubmit}
              disabled={
                !formik.dirty ||
                !formik.isValid ||
                MainUtils.isEmptyValue(id) ||
                MainUtils.isEmptyValue(formik.values.TestEmail) ||
                !emailRegex.test(formik.values.TestEmail) ||
                isLoading
              }
              icon={<FiSend className='add-button-icon' />}
              type='primary'
              text={messages['mailing.sendTestEmail'].toString()}
              size='small'
              className='add-button'
            />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default TestCampaigns;
